import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { CheckIcon, XCircleIcon, TrashIcon, MessageCircleIcon } from '../../components/icons/Icons';
import api from '../../services/api';
import AdminLayout from './AdminLayout';
import './Comments.css';

const Comments = () => {
  const [comments, setComments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState('pending');

  useEffect(() => {
    fetchComments();
  }, [filter]);

  const fetchComments = async () => {
    try {
      setLoading(true);
      const response = await api.get(`/comments/admin/all?status=${filter}`);
      setComments(response.data);
    } catch (error) {
      console.error('Failed to fetch comments:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleApprove = async (id) => {
    try {
      await api.put(`/comments/admin/${id}/approve`);
      setComments(comments.filter(c => c.id !== id));
    } catch (error) {
      alert('Failed to approve comment');
    }
  };

  const handleReject = async (id) => {
    try {
      await api.put(`/comments/admin/${id}/reject`);
      setComments(comments.filter(c => c.id !== id));
    } catch (error) {
      alert('Failed to reject comment');
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Are you sure you want to delete this comment?')) return;

    try {
      await api.delete(`/comments/admin/${id}`);
      setComments(comments.filter(c => c.id !== id));
    } catch (error) {
      alert('Failed to delete comment');
    }
  };

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  return (
    <AdminLayout>
      <div className="admin-page-header">
        <h1 className="admin-page-title">Comments</h1>
      </div>

      <div className="comments-filter">
        <button 
          className={`filter-btn ${filter === 'pending' ? 'active' : ''}`}
          onClick={() => setFilter('pending')}
        >
          Pending
        </button>
        <button 
          className={`filter-btn ${filter === 'approved' ? 'active' : ''}`}
          onClick={() => setFilter('approved')}
        >
          Approved
        </button>
        <button 
          className={`filter-btn ${filter === 'rejected' ? 'active' : ''}`}
          onClick={() => setFilter('rejected')}
        >
          Rejected
        </button>
      </div>

      <div className="admin-card">
        {loading ? (
          <p className="comments-empty">Loading comments...</p>
        ) : comments.length === 0 ? (
          <div className="comments-empty">
            <MessageCircleIcon size={48} />
            <p>No {filter} comments</p>
          </div>
        ) : (
          <div className="comments-list-admin">
            {comments.map(comment => (
              <div key={comment.id} className="comment-admin-item">
                <div className="comment-admin-header">
                  <div className="comment-admin-info">
                    <span className="comment-admin-author">{comment.author_name}</span>
                    <span className="comment-admin-email">{comment.author_email}</span>
                  </div>
                  <span className="comment-admin-date">{formatDate(comment.created_at)}</span>
                </div>
                
                <div className="comment-admin-post">
                  On: <Link to={`/blog/${comment.post_slug}`} target="_blank">
                    {comment.post_title}
                  </Link>
                </div>
                
                <p className="comment-admin-content">{comment.content}</p>
                
                <div className="comment-admin-actions">
                  {filter === 'pending' && (
                    <>
                      <button 
                        onClick={() => handleApprove(comment.id)}
                        className="admin-btn-action approve"
                      >
                        <CheckIcon size={16} /> Approve
                      </button>
                      <button 
                        onClick={() => handleReject(comment.id)}
                        className="admin-btn-action reject"
                      >
                        <XCircleIcon size={16} /> Reject
                      </button>
                    </>
                  )}
                  <button 
                    onClick={() => handleDelete(comment.id)}
                    className="admin-btn-action delete"
                  >
                    <TrashIcon size={16} /> Delete
                  </button>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </AdminLayout>
  );
};

export default Comments;
